import { Component, Input } from '@angular/core';
import {
    FormInputComponent,
    InputComponentConfig,
} from '@vendure/admin-ui/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
    selector: 'mandatory-variants-form-input',
    imports: [],
    template: ` <div></div> `,
})
export class HiddenFormInput
    implements FormInputComponent<InputComponentConfig>
{
    @Input() readonly: boolean = false;
    @Input() formControl!: FormControl;
    @Input() config!: InputComponentConfig;
}
